import { Portal, Stack } from "@mui/material";
import { ReactNode } from "react";
import { Drawer, IconButton } from "@mui/material";
import { theme } from "@theme";
import CloseIcon from "@mui/icons-material/Close";
import { PAGE_HEADER_HEIGHT } from "@constants";

interface Props {
  children: ReactNode;
  permanent: boolean;
  setOpen: (open: boolean) => void;
  open: boolean;
  drawerWidth: number;
  header?: ReactNode;
}

const PortaledRightDrawer = ({
  permanent,
  open,
  setOpen,
  children,
  drawerWidth,
  header,
}: Props) => {
  const topOffset = document.getElementById("app-bar")?.clientHeight;
  const container = document.getElementById("layout-right-bar");
  return (
    <Portal container={container}>
      <Drawer
        variant={permanent ? "permanent" : "temporary"}
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
        }}
        slotProps={{
          paper: {
            sx: {
              width: drawerWidth,
              zIndex: theme.zIndex.appBar - 1,
              top: topOffset,
              height: `calc(100vh - ${topOffset}px)`,
            },
          },
        }}
      >
        <Stack
          direction="row"
          gap={2}
          sx={{
            minHeight: PAGE_HEADER_HEIGHT,
            maxHeight: PAGE_HEADER_HEIGHT,
            paddingX: permanent ? 0 : 2,
            borderBottom: "1px solid",
            borderColor: "divider",
            alignItems: "center",
          }}
        >
          {!permanent && (
            <IconButton
              onClick={() => setOpen(false)}
              color="secondary"
              data-testid="right-drawer-close-button"
            >
              <CloseIcon />
            </IconButton>
          )}
          {header && header}
        </Stack>
        {children}
      </Drawer>
    </Portal>
  );
};

export default PortaledRightDrawer;
